import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Shield } from 'lucide-react';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('p4c_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('p4c_cookie_consent', 'accepted');
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
    }
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('p4c_cookie_consent', 'declined');
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
      });
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[90] p-4 md:p-6"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="bg-[#121212] border border-zinc-800 rounded-md p-6 md:p-8 backdrop-blur-xl shadow-2xl shadow-black/50">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <Shield className="w-8 h-8 text-[#ED2227] shrink-0 hidden md:block" strokeWidth={1.5} />
            <div className="flex-1">
              <h3 className="text-white font-bold text-base font-[Chivo] mb-1">
                We Value Your Privacy
              </h3>
              <p className="text-zinc-400 text-sm leading-relaxed">
                We use cookies to enhance your browsing experience and analyze site traffic. By clicking "Accept All", you consent to our use of cookies. Read our{' '}
                <Link to="/legal/cookies" className="text-[#ED2227] hover:underline">Cookie Policy</Link>{' '}
                and{' '}
                <Link to="/legal/privacy-policy" className="text-[#ED2227] hover:underline">Privacy Policy</Link>{' '}
                for more information.
              </p>
            </div>
            <div className="flex gap-3 shrink-0 w-full md:w-auto">
              <Button
                onClick={decline}
                variant="outline"
                className="flex-1 md:flex-none border-zinc-700 text-zinc-400 hover:bg-zinc-800 hover:text-white rounded-sm text-xs uppercase tracking-wider h-10 px-6"
                data-testid="cookie-decline-btn"
              >
                Decline
              </Button>
              <Button
                onClick={accept}
                className="flex-1 md:flex-none bg-[#ED2227] text-white hover:bg-red-700 rounded-sm font-bold text-xs uppercase tracking-wider h-10 px-6"
                data-testid="cookie-accept-btn"
              >
                Accept All
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
